import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { cn } from '@/lib/utils';

interface BackArrowProps {
  to?: string;
  className?: string;
}

export function BackArrow({ to, className }: BackArrowProps) {
  const navigate = useNavigate();
  
  const handleClick = () => {
    if (window.history.length > 1) {
      navigate(-1);
    } else {
      navigate(to ?? '/dashboard');
    }
  };

  return (
    <button
      onClick={handleClick}
      className={cn(
        "flex items-center text-muted-foreground hover:text-foreground transition-colors mr-3",
        className
      )}
    >
      <ArrowLeft className="h-5 w-5" />
    </button>
  );
}
